const dataTableData = {
  columns: [
    { Header: "#", accessor: "id", width: "5%" },
    { Header: "الشعار", accessor: "logo", width: "10%" },
    { Header: "اسم الشركة", accessor: "name", width: "15%" },
    { Header: "البريد الإلكتروني", accessor: "email", width: "15%" },
    { Header: "الموقع الإلكتروني", accessor: "website", width: "15%" },
    { Header: "رقم الهاتف", accessor: "phoneNumber", width: "15%" },
    { Header: "الرقم المختصر", accessor: "shortNumber", width: "15%" },
    { Header: "اجراء", accessor: "actions", width: "10%" },
  ],

  rows: [], // Will be populated with API data
};

export default dataTableData;
